import React, { useState, useEffect, useRef } from "react";
import { fetchdata2, send_sms, otp_verification, sendwebtocasebackend, setActivity } from "../../Global/Index";
import { useTheme } from "@mui/material";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import "../ComplaintWeb/Complaint.css";
import HeaderMobile from './HeaderMobile'
import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';


const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: "50%",
};


const Timer = ({ initialTime, onExpire }) => {
    const [time, setTime] = useState(initialTime);
    const timerRef = useRef(null);

    useEffect(() => {
        timerRef.current = setInterval(() => {
            setTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timerRef.current);
                    onExpire();
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timerRef.current);
    }, [onExpire]);

    return <p className="timer">{time > 0 ? `OTP will expire in ${time} seconds` : 'OTP has expired'}</p>;
};




const ComplaintForm = () => {
    const [apdata, setApdata] = useState([]);
    const theme = useTheme();
    const [alterphone, setAlterphone] = useState("");
    const [oTP, setOTP] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isResendOtp, setIsResendOtp] = useState(false);
    const [timerKey, setTimerKey] = useState(0); // Add this line
    const [isOpen, setIsOpen] = useState(false);
    const [isotpverified, setIsotpverified] = useState(false);
    const [submitdata, setSubmitdata] = useState(false);
    const [phonenum, setPhonenum] = useState("");
    const [name, setName] = useState("");
    const ref = React.createRef();
    const { mbl } = useParams();


    // Validation helper functions
    const validateAPId = (apId) => {
        if (apId === "") {
            toast.error("Please select an AP Id");
            return false;
        }
        return true;
    };

    const validateComplaintType = (complaintType) => {
        if (complaintType === "") {
            toast.error("Please select a complaint type");
            return false;
        }
        return true;
    };

    const validateName = (name) => {
        const nameRegex = /^[a-zA-Z\s]+$/;

        if (name.trim() === "") {
            toast.error("Contact Name can't be blank");
            return null;
        }

        if (name.charAt(0) === ' ') {
            toast.error("Error: The name must not begin with a space.");
            return null;
        }

        if (!nameRegex.test(name.trim())) {
            toast.error("Name does not match the format.");
            return null;
        }

        return name.trim();
    };

    const validateAlternatePhone = (phone, isotpverified) => {
        const phoneRegex = /^\d{10}$/;

        if (phone.length > 0) {
            if (!phoneRegex.test(phone) || !isotpverified) {
                toast.warn("Please verify otp before submitting the form.");
                return false;
            }
        }
        return true;
    };

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (email == "" || emailRegex.test(email)) {
            return email.toLowerCase().trim();
        }

        toast.error("Please use a valid email id");
        return null;
    };

    const validateSubject = (subject) => {
        const subjectRegex = /^[^<>{}&]*$/;
        const trimmedSubject = subject.trim();

        if (trimmedSubject === "") {
            toast.error("Subject can't be blank");
            return null;
        }

        if (subject.charAt(0) === ' ') {
            toast.error("Error: The Subject must not begin with a space.");
            return null;
        }

        if (!subjectRegex.test(trimmedSubject)) {
            toast.error("Subject does not match the format.");
            return null;
        }

        return trimmedSubject;
    };

    const validateDescription = (description) => {
        const descriptionRegex = /^[^<>{}&]*$/;
        const trimmedDescription = description.trim();

        if (trimmedDescription === "") {
            toast.error("Description can't be blank");
            return null;
        }

        if (description.charAt(0) === ' ') {
            toast.error("Error: The Description must not begin with a space.");
            return null;
        }

        if (!descriptionRegex.test(trimmedDescription)) {
            toast.error("Description does not match the format.");
            return null;
        }

        return trimmedDescription
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    };

    const validateExternal = (external) => {
        const externalRegex = /^[01]$/;

        if (!externalRegex.test(external)) {
            toast.error("External value does not match the format.");
            return null;
        }

        return parseInt(external, 10);
    };

    const createFormWithData = (validationResults, data) => {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = process.env.REACT_APP_WEB_TO_CASE_URL;

        // Append all validated data to the form
        for (const key in validationResults) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = validationResults[key];
            form.appendChild(input);
        }

        // Append the original hidden inputs
        const hiddenInputs = [
            { name: 'orgid', value: data.orgid },
            { name: 'retURL', value: data.retURL },
            { name: 'external', value: '1' },
            { name: '00N2K00000E6xMP', value: data.phonenum },
            { name: '00N2K00000EBBK9', value: data["00N2K00000EBBK9"] },
            { name: '00N2K00000Cmdsb', value: data["00N2K00000Cmdsb"] },
            { name: '00N2K00000E6xMU', value: data["00N2K00000E6xMU"] },
        ];

        hiddenInputs.forEach(({ name, value }) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });

        return form;
    };

    // Main handler function - Cognitive Complexity: 8
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());
        const validationResults = {};

        // Validate AP ID
        if (!validateAPId(data["00N2K00000EBBK9"])) return;

        // Validate Type of complaint
        if (!validateComplaintType(data["00N2K00000Cmdsb"])) return;

        // Validate name
        const validatedName = validateName(data.name);
        if (validatedName === null) return;
        validationResults.name = validatedName;

        // Validate alternate phone number
        if (!validateAlternatePhone(data["00N2K00000E6xMU"], isotpverified)) return;

        // Validate email
        const validatedEmail = validateEmail(data.email);
        if (validatedEmail === null) return;
        validationResults.email = validatedEmail;

        // Validate subject
        const validatedSubject = validateSubject(data.subject);
        if (validatedSubject === null) return;
        validationResults.subject = validatedSubject;

        // Validate description
        const validatedDescription = validateDescription(data.description);
        if (validatedDescription === null) return;
        validationResults.description = validatedDescription;

        // Validate external
        const validatedExternal = validateExternal(data.external);
        if (validatedExternal === null) return;
        validationResults.external = validatedExternal;

        // Process form submission
        data['mode'] = "I-Serve App";
        // console.log(`Response of form data is ${JSON.stringify(data)}`);

        const resp = await sendwebtocasebackend(data);
        // console.log(`response of send web to case backedn url is ${JSON.stringify(resp)}`);

        if (resp.status == "500") {
            toast.error(resp.message);
            return;
        }

        setSubmitdata(true);

        const form = createFormWithData(validationResults, data);
        document.body.appendChild(form);

        setActivity('Compliant Raise Mobile Page');

        setTimeout(() => {
            form.submit();
        }, 3000);
        toast.success('Your complaint has been successfully registered!');
    };



    const handleTimerExpire = () => {
        setIsResendOtp(true);
    };


    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [ref]);




    const handleOtpChange = (e) => {
        setOTP(e.target.value);
    };


    const handleSendOtp = async () => {
        if (alterphone == phonenum) {
            toast.error("Please enter different number than registered number.");
            return;
        }

        const phoneRegex = /^\d{10}$/;
        if (phoneRegex.test(alterphone)) {
            setIsResendOtp(false);
            setOTP('');
            handleToggleClose();
            setTimerKey(prevKey => prevKey + 1);
            try {
                const response = await send_sms(alterphone);
                console.log(`response of send sms is ${JSON.stringify(response)}`)
            } catch (error) {
                toast.error(error);
            }
        } else {
            toast.error("Phone enter 10 digit number.");
        }

    };


    const handleResendOtp = () => {
        handleSendOtp();
    };

    const handlefun = () => {
        setIsotpverified(true);
        setIsOpen(false);
        toast.success("OTP verified successfully!");
    }

    useEffect(() => {

        const fetchData = async () => {

            try {
                const data = await fetchdata2(mbl);
                console.log("Data fetched successfully", JSON.stringify(data));
                if (data?.response?.status === "200") {
                    const loanNumbers = data.response.data.loanList.map(
                        (loan) => loan.LoanAccountNumber
                    );
                    console.log("Loan Numbers", loanNumbers);
                    setApdata(loanNumbers);
                    setPhonenum(data.response.mobilenum)
                    setName(data.response.name)
                } else {
                    setApdata([]);
                    toast.warn(data.response.message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }

        };
        fetchData();
    }, [])


    // Function to format the mobile number
    const formatMobileNumber = (number) => {
        if (number && number.length >= 4) {
            const lastTwoDigits = number.slice(-4);
            const maskedNumber = 'XXXXXX' + lastTwoDigits;
            return maskedNumber;
        }
        return 'Invalid number';
    };

    const handleToggleClose = () => {
        setIsOpen(true);
        setIsOtpSent(true);
    }
    const handleToggleClose1 = () => {
        setIsOpen(false);
    }

    const handleVerifyOtp = async () => {
        try {
            const Mobile_Num = alterphone;
            const response = await otp_verification({ Mobile_Num, oTP });
            console.log(`Response of OTP verification is ${JSON.stringify(response)}`);
            if (response.status === 201) {
                handlefun();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error("Something went wrong. Please try again later!");
        }
    };




    return (
        <>
            <HeaderMobile />
            <div
                className="maincontainer"
                style={{
                    backgroundColor: theme.palette.background.alt,
                    color: theme.palette.primary.main,
                }}
            >
                <h2>Raise Complaint</h2>
                {apdata != null ? (
                    <div className="mainsubcontainer Compliantmain">
                        <div className="left">
                            <img src={require("../../Images/raise.png")} alt="Complaint" style={{ width: '100%' }} />
                        </div>
                        {

                            isOpen && (

                                <div className="emailoutercontainer">

                                    <div className="email-verification-container" ref={ref} style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.main }} >
                                        <div style={{ textAlign: 'right', fontSize: '3vh' }}>
                                            <button
                                                type="button"
                                                onClick={handleToggleClose1}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        handleToggleClose1();
                                                    }
                                                }}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: 'inherit',
                                                    padding: '0',
                                                    color: 'inherit'
                                                }}
                                                aria-label="Close"
                                            >
                                                <i className="bi bi-x-lg" />
                                            </button>
                                        </div>
                                        <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                                            An OTP has been sent to your mobile number {formatMobileNumber(alterphone)}.
                                        </div>

                                        {isOtpSent && (
                                            <div>
                                                {!isResendOtp && <input maxLength={6} type="tel" className="otp-input" value={oTP} onChange={handleOtpChange} placeholder="Enter OTP" />}
                                                {!isResendOtp && <button className="verify-otp-button" onClick={handleVerifyOtp}>
                                                    Verify OTP
                                                </button>}
                                                {!isResendOtp && (
                                                    <Timer key={timerKey} initialTime={60} onExpire={handleTimerExpire} />
                                                )}
                                                {isResendOtp && (
                                                    <button className="resend-otp-button" onClick={handleResendOtp} >
                                                        Resend OTP
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>)
                        }
                        <div className="right">
                            <h3>Write To Us. You Can Reach Us For Any Query</h3>

                            <form
                                onSubmit={handleSubmit}
                                id='myForm'
                            >
                                <div className="forminputDiv">
                                    <input type="hidden" name="orgid" value="00DA0000000YXIu" />
                                    <input type="hidden" name="retURL" value={`https://customerportal.indiashelter.in/raiseComplaintMobile/${mbl}`} />

                                    <div className="forminput">
                                        <label htmlFor="Complaint">Type of Complaint <span style={{ color: 'red' }}>*</span> :</label>
                                        <select
                                            id="00N2K00000Cmdsb"
                                            name="00N2K00000Cmdsb"
                                            title="Type of Complaint"
                                        >
                                            <option value="">--None--</option>
                                            <option value="Ex-gratia Payment">Ex-gratia Payment</option>
                                            <option value="Others">Others</option>
                                            <option value="Cancel Mandate">Cancel Mandate</option>
                                        </select>
                                    </div>

                                    <input id="00N2K00000EBBK9" maxLength="255" name="00N2K00000EBBK9" size="20" type="hidden" />
                                    <div className="forminput">
                                        <label htmlFor="APID" >Application id <span style={{ color: 'red' }}>*</span> :</label>
                                        <select
                                            onChange={(e) => {
                                                document.getElementById("00N2K00000EBBK9").value = e.target.value;
                                                console.log(e.target.value);
                                            }}
                                        >
                                            <option value="">Please Select</option>
                                            {apdata?.map((item, index) => (
                                                <option key={index + 1} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                        {/* <input id="00N2K00000EBBK9" maxlength="100" name="00N2K00000EBBK9" size="20" type="text" /> */}
                                    </div>

                                    <div className="forminput">
                                        <label htmlFor="name">Contact Name <span style={{ color: 'red' }}>*</span> :</label>
                                        <input
                                            id="name"
                                            maxLength="80"
                                            name="name"
                                            size="20"
                                            type="text"
                                            value={name}
                                            onChange={(e) => { setName(e.target.value) }}
                                        />
                                    </div>

                                    <div className="forminput">
                                        <label htmlFor="email">Email:</label>
                                        <input
                                            id="email"
                                            maxLength="80"
                                            name="email"
                                            size="20"
                                            type="text"
                                        />
                                    </div>

                                    <div className="forminput">
                                        <label htmlFor="phone">Phone Number <span style={{ color: 'red' }}>*</span> :</label>
                                        <input id="00N2K00000E6xMP" maxLength="40" name="00N2K00000E6xMP" size="20" type="text" value={phonenum} disabled={true} />
                                        <input maxLength="40" name="phonenum" size="20" type="hidden" value={phonenum} />
                                    </div>
                                    <div className="forminput">

                                        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', marginTop: '.5vh' }}>
                                            <div htmlFor="Altphone">Alternative Phone:</div>
                                            {
                                                !isotpverified && <button
                                                    className="toggle-button"
                                                    onClick={handleSendOtp}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            handleSendOtp();
                                                        }
                                                    }}
                                                    style={{
                                                        color: 'rgb(155,19,74)',
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        textAlign: 'right',
                                                        background: 'none',
                                                        border: 'none',
                                                        padding: '0',
                                                        font: 'inherit',
                                                        marginBottom: '.3vh'
                                                    }}
                                                    type="button"
                                                >
                                                    Send OTP
                                                </button>
                                            }
                                        </div>

                                        <input id="00N2K00000E6xMU" maxLength="40" name="00N2K00000E6xMU" size="20" type="text" onChange={(e) => { setAlterphone(e.target.value) }} disabled={isotpverified} />

                                    </div>

                                    <input id="00N2K00000E6xMU" maxLength="40" name="00N2K00000E6xMU" size="20" type="hidden" value={alterphone} />

                                    <div className="forminput description">
                                        <label htmlFor="subject">Subject <span style={{ color: 'red' }}>*</span> :</label>
                                        <input id="subject" maxLength="80" name="subject" size="20" type="text" />
                                    </div>
                                </div>

                                <div className="forminput description">
                                    <label htmlFor="description">Description <span style={{ color: 'red' }}>*</span> :</label>
                                    <textarea name="description"></textarea>
                                </div>
                                <br />

                                <input type="hidden" id="external" name="external" value="1" />

                                <div style={{ textAlign: "center" }}>
                                    <button type="submit" name="submit" style={{
                                        backgroundColor: 'rgb(155,19,74)', color: 'white', padding: "1vh 0vh", borderRadius: '20px', border: 'none',
                                        width: '25%', margin: 'auto', fontSize: '15px', cursor: 'pointer'
                                    }} disabled={submitdata}>{submitdata === false ? "Submit" : "Please wait"}</button>
                                </div>
                            </form>
                        </div>
                    </div>

                ) : (
                    <ClipLoader
                        color={theme.palette.maincolor.light}
                        loading={true}
                        cssOverride={override}
                        size={30}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                )}
            </div>
        </>
    );
};
// Prop validation
Timer.propTypes = {
    initialTime: PropTypes.number.isRequired,
    onExpire: PropTypes.func.isRequired, // Assuming onExpire is a function
};


export default ComplaintForm;
